export default {
    lesson: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/lesson/state.js